import { render } from "./InspectorContainer.vue?vue&type=template&id=2929d108&scoped=true"
import script from "./InspectorContainer.vue?vue&type=script&lang=js"
export * from "./InspectorContainer.vue?vue&type=script&lang=js"

import "./InspectorContainer.vue?vue&type=style&index=0&id=2929d108&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2929d108"]])

export default __exports__